/**
 * Superfleet.ai Confidential
 * ----------------------
 * Created by Tigran Yengibaryan on 12/23/2023
 * All Rights Reserved.
 */
import { ColorLabel } from '../../global/components/SFColorPalette';

export type GeofenceFormValues = {
  name: string;
  description: string;
  color: ColorLabel;
  address: string;
  addressOn: boolean;
  addressCoordinate: string;
  distance: number;
};
export type ColorScheme = {
  id: number;
  label: string;
  fillColor: string;
  strokeColor: string;
};
export type GeofenceColorScheme = Array<ColorScheme>;
export type GeofenceRequestDTO = {
  name: string;
  description: string;
  polygon?: number[][];
  color: ColorLabel;
  circle?: {
    lat: number;
    lng: number;
    radius: number;
  };
};

export type GeofenceListResponseDTO = {
  items: Array<{
    id: string;
    name: string;
    description: string;
    polygon: Array<[Array<number>]>;
    createdAt: string;
    updatedAt: string;
    label: string;
  }>;
  limit?: number;
  moreItems?: boolean;
  offset?: number;
  totalItems?: number;
};

export interface GeofenceCircle {
  lat: number;
  lng: number;
  radius: number;
}

export enum GeofenceSearchOption {
  NAME = 'name',
  DESCRIPTION = 'description',
}
